export const AuthorizationMethod = Object.freeze({
  BASIC: Symbol('HTTP Basic Authorization'),
  ENCRYPTED_CREDENTIALS: Symbol(
    'RSA-encrypted user credentials JSON sent via HTTP POST',
  ),
});
